import cn from 'classnames';
import React, { ReactNode } from 'react';

import s from './TextButton.module.scss';

interface TextButton {
  children: ReactNode;
  className?: string;
  isActive?: boolean | null;
  icon?: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const TextButton = ({ children, className, icon, isActive, onClick, ...props }: TextButton) => (
  <button
    onClick={onClick}
    className={cn(
      s.TextButton,
      { [s.TextButton__active]: isActive, [s.TextButton__with_icon]: !!icon },
      className
    )}
    {...props}
  >
    {icon && <span className={s.TextButton__icon_holder}>{icon}</span>}
    <span className={s.TextButton__text_holder}>{children}</span>
  </button>
);

export default TextButton;
